const WORDS = ["Bazuka", "Spander", "Plant Flex", "Bazuka Front", "Bazuka Mix", "Guincho Munk Bag", "Desde 1996 · Assis/SP"];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-line bg-white py-4" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
          {WORDS.map((w) => (
            <span key={w} className="flex items-center font-display text-2xl font-semibold uppercase tracking-wide text-ink sm:text-3xl">
              <span className="px-8">{w}</span>
              <span className="h-2.5 w-2.5 rotate-45 bg-brand" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
